import {dayjs} from "./dateUtils";

function checkAvailability(marketSchedule, selector) {
    if (!marketSchedule)  {
      return;
    }

    const weekdaysSchedule = [];
    let lastTime = null;
    marketSchedule.forEach((day) => {
      const dayName = window.i18next.t(`layout.itemprop.cs_schedule.${day.day}`);
      const time = (day.from === null || day.to === null)
          ? window.i18next.t('layout.closed')
          : `${day.from}–${day.to}`;
      if (lastTime === time && day.day !== 'holidays') {
        weekdaysSchedule[weekdaysSchedule.length - 1].days.push(dayName);
      } else {
        weekdaysSchedule.push({ time, days: [dayName] });
        lastTime = time;
      }
    });

    weekdaysSchedule.forEach((schedule) => {
      const end = schedule.days.length > 1 ? schedule.days[schedule.days.length - 1] : null;
      schedule.days = end ? `${schedule.days[0]}-${end}` : schedule.days[0];
    });

    const schedule = weekdaysSchedule.map((schedule) => `${schedule.days} ${schedule.time}`).join(', ').replace(/,([^,]*)$/, ' ' + window.i18next.t('layout.subscription.and') + '$1');
    const section = selector === '#phone-support' ? 'call_us' : 'live_chat';

    $(`${selector} .schedule-text`).html(
      window.i18next.t(`subscription.contact_us.${section}.body`, { schedule })
    );

    const now = dayjs().tz(window.timezone);
    const todayName = now.format("dddd");
    const todayHours = marketSchedule.find((day) => day.day === todayName.toLowerCase().substring(0, 2));
    if (!todayHours) {
        return;
    }

    let available = false;

    if (todayHours.from !== null && todayHours.to !== null) {
      const startTime = now.clone().hour(todayHours.from.split(":")[0]).minute(todayHours.from.split(":")[1]);
      const endTime = now.clone().hour(todayHours.to.split(":")[0]).minute(todayHours.to.split(":")[1]);
      available = now.isBetween(startTime, endTime, undefined, '[]');
    }

    if (available) {
      $(`${selector} .availabilityText`).text(window.i18next.t('subscription.contact_us.available'))
        .addClass('available')
        .removeClass('unavailable');

      $('#phone-support #call-button').hide();
      $('#phone-support #call-button-unavailable').show();
      if (window.hasCXCallFeatureEnabled) {
          setupPhoneCall();
          toggleRequestCallBackButton();
      }
    }
}

function setupPhoneCall() {
    const platform = navigator?.userAgentData?.platform || navigator.platform;
    const macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];

    const protocol = (macosPlatforms.indexOf(platform) !== -1) ? 'tel' : 'callto';
    $('#phone-support a').attr('href', `${protocol}:${window.csPhone}`);
}

function toggleRequestCallBackButton() {
    const customerSupportOnline = $('#phone-support .availabilityText').hasClass('available');
    if (!customerSupportOnline) {
        $('#phone-support #call-button').hide();
        $('#phone-support #call-button-unavailable').show();
    }
}
$(document).ready(function () {
    $('.availabilityText').text(window.i18next.t('subscription.contact_us.offline'))
      .addClass('unavailable')
      .removeClass('available');

    checkAvailability(window.csSchedule, '#whatsapp-support');
    checkAvailability(window.lcSchedule, '#live-chat-support');
    if (window.hasCXCallFeatureEnabled) {
        checkAvailability(window.csSchedule, '#phone-support');
        setupPhoneCall();
        toggleRequestCallBackButton();
    }
    setInterval(() => {
        if (window.hasCXCallFeatureEnabled) {
            checkAvailability(window.csSchedule, '#phone-support');
        }
        checkAvailability(window.csSchedule, '#whatsapp-support');
        checkAvailability(window.lcSchedule, '#live-chat-support');
    }, 60000);
});
